import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Heart } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      nav("/", { replace: true });
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center p-6 relative overflow-hidden">
      {/* Soft background accents */}
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-forest-soft opacity-60 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-terracotta/10 blur-3xl" />

      <div className="relative w-full max-w-md">
        <div className="mb-8 flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-forest text-white grid place-items-center font-outfit font-bold text-xl">
            H
          </div>
          <div>
            <div className="font-outfit font-bold text-2xl text-ink leading-tight">Hygenix Healthcare</div>
            <div className="font-figtree text-sm text-ink-soft">Order &amp; Dispatch</div>
          </div>
        </div>

        <div className="card-surface p-8">
          <h1 className="font-outfit font-bold text-3xl text-ink">Sign in</h1>
          <p className="font-figtree text-ink-soft mt-2 mb-8">
            Welcome back. Enter your credentials to manage your orders &amp; dispatch.
          </p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="font-figtree font-medium text-sm text-ink block mb-2">Username</label>
              <input
                data-testid="login-email-input"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                className="w-full h-12 px-4 rounded-lg border border-line bg-white font-figtree text-ink outline-none focus:ring-2 focus:ring-forest focus:border-forest transition-colors duration-200"
                placeholder="admin"
              />
            </div>

            <div>
              <label className="font-figtree font-medium text-sm text-ink block mb-2">Password</label>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full h-12 px-4 rounded-lg border border-line bg-white font-figtree text-ink outline-none focus:ring-2 focus:ring-forest focus:border-forest transition-colors duration-200"
                placeholder="••••••••"
              />
            </div>

            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="btn-primary w-full h-12 text-base disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-line">
            <div className="flex items-start gap-2 text-sm text-ink-soft font-figtree">
              <Heart className="h-4 w-4 mt-0.5 text-terracotta flex-shrink-0" />
              <span>
                Built for tracking orders, dispatches, buyers &amp; employees — all in one calm place.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
